var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTpcIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17815_26667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17815_26667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6016 12.5874H13.8633V32.144H12.6016V12.5874Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4805 12.5874H27.7422V32.144H26.4805V12.5874Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8952 33.6938C30.8952 32.6492 30.0473 31.8012 29.0028 31.8012H11.3387C10.2932 31.8012 9.44531 32.6492 9.44531 33.6938V34.9555C9.44531 35.3039 9.72794 35.5864 10.0764 35.5864H30.264C30.6125 35.5864 30.8952 35.3039 30.8952 34.9555V33.6938ZM29.6329 33.6938V34.3247H10.7076V33.6938C10.7076 33.3456 10.9902 33.063 11.3387 33.063H29.0028C29.3503 33.063 29.6329 33.3456 29.6329 33.6938Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1094 3.12449C27.1094 2.07997 26.2614 1.2319 25.2168 1.2319H20.1699C19.8216 1.2319 19.5391 1.51428 19.5391 1.8627V5.64787C19.5391 5.99629 19.8216 6.27867 20.1699 6.27867H25.2168C26.2614 6.27867 27.1094 5.4306 27.1094 4.38608V3.12449ZM25.8477 3.12449V4.38608C25.8477 4.73432 25.5651 5.01707 25.2168 5.01707H20.8008V2.4935H25.2168C25.5651 2.4935 25.8477 2.77625 25.8477 3.12449Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50781 22.0503V32.144C2.50781 32.4923 2.78991 32.7749 3.13841 32.7749H13.2322C13.5802 32.7749 13.8633 32.4923 13.8633 32.144C13.8628 31.7958 13.5802 31.5132 13.2322 31.5132H3.769C3.76954 31.5132 3.76954 22.0503 3.76954 22.0503C3.76954 21.702 3.48638 21.4194 3.13841 21.4194C2.79044 21.4194 2.50781 21.702 2.50781 22.0503Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2344 16.3725H5.03345C4.79412 16.3725 4.57568 16.5075 4.46899 16.7213L1.94532 21.7682C1.84766 21.9637 1.85839 22.1959 1.97297 22.3819C2.08812 22.5678 2.29133 22.6811 2.50977 22.6811H13.2344V21.4194H3.53031L5.42292 17.6343H13.2344V16.3725Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1111 32.7749H37.2049C37.5534 32.7749 37.836 32.4923 37.836 32.144V22.0503C37.836 21.702 37.5528 21.4194 37.2049 21.4194C36.8569 21.4194 36.5743 21.702 36.5743 22.0503V31.5132H27.1111C26.7631 31.5132 26.4805 31.7958 26.4805 32.144C26.4799 32.4923 26.7631 32.7749 27.1111 32.7749Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1133 22.6811H37.8379C38.0564 22.6811 38.2596 22.5678 38.3747 22.3819C38.4893 22.1959 38.5 21.9637 38.4024 21.7682L35.8787 16.7213C35.772 16.5075 35.5536 16.3725 35.3142 16.3725H27.1133V17.6343H34.9248L36.8174 21.4194H27.1133V22.6811Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3281 32.1442V26.4664C23.3281 25.0738 22.1974 23.9428 20.8047 23.9428H19.543C18.1503 23.9428 17.0195 25.0738 17.0195 26.4664V32.1442H18.2813V26.4664C18.2813 25.7699 18.8465 25.2048 19.543 25.2048H20.8047C21.5012 25.2048 22.0664 25.7699 22.0664 26.4664V32.1442H23.3281Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3734 13.2182C28.6537 13.2182 28.9012 13.0328 28.9795 12.7632C29.0578 12.494 28.9482 12.2051 28.7111 12.0549L22.7466 8.26977C22.646 8.20542 22.5289 8.17136 22.4089 8.17136H17.9355C17.8155 8.17136 17.6984 8.20542 17.5978 8.26977L11.6333 12.0549C11.3962 12.2051 11.2866 12.494 11.3649 12.7632C11.4432 13.0328 11.6907 13.2182 11.971 13.2182H28.3734ZM26.2015 11.9565H14.1421L18.1189 9.43308H22.2255L26.2015 11.9565Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8047 5.01706V8.80222H19.543V5.01706H20.8047Z",
    fill: "#97A6A5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17815_26667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 35,
    fill: "white",
    transform: "translate(0.800781 0.846161)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17815_26667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 35,
    fill: "white",
    transform: "translate(0.800781 0.846161)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpcIcon);
export default __webpack_public_path__ + "static/media/tpcIcon.70517e14abdb7641ba67a79ba92d5344.svg";
export { ForwardRef as ReactComponent };